import React from 'react';
import PropTypes from 'prop-types';

import Card from 'common/components/card';
import CardHeader from 'common/components/card-header';
import CardContent from 'common/components/card-content';

import Map from './components/map';
import './index.scss';

const identity = (x) => x;

export default class MapCard extends React.Component {
  static propTypes = {
    buildings: PropTypes.array.isRequired,
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    forExport: PropTypes.bool,
    height: PropTypes.number,
    inStoryboard: PropTypes.bool,
    meta: PropTypes.object.isRequired,
    priorityWarnings: PropTypes.array,
    reportId: PropTypes.number,
    title: PropTypes.string.isRequired,
    warnings: PropTypes.array,
  };

  static defaultProps = {
    disableConfig: false,
    forExport: false,
    height: 200,
    inStoryboard: false,
  };

  constructor(props) {
    super(props);
    this._initializeCache();
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.height !== nextProps.height ||
      this.props.title !== nextProps.title ||
      this.hasDifferentBuildings(nextProps)
    );
  }

  setCache(buildings) {
    this._cache.buildings = new Set(buildings.map((building) => building.id));
  }

  _initializeCache() {
    this._cache = {};
  }

  hasDifferentBuildings(nextProps) {
    const numNewBuildings = nextProps.buildings.filter(
      (building) => !this._cache.buildings.has(building.id),
    ).length;
    const hasNewBuildings = numNewBuildings > 0;
    const hasDifferentNumberOfBuildings =
      nextProps.buildings.length !== this._cache.buildings.size;
    return hasNewBuildings || hasDifferentNumberOfBuildings;
  }

  render() {
    this.setCache(this.props.buildings);

    return (
      <div
        className={`MapCard ${
          this.props.forExport ? 'MapCard--forExport' : ''
        }`}>
        <Card
          className={`MapCard-Card ${
            this.props.disableConfig ? 'u-cursor-default' : 'u-cursor-move'
          }`}
          loading={false}>
          {(this.props.connectDragSource || identity)(
            <div>
              <CardHeader
                disableConfig={this.props.disableConfig}
                disableDownloadCsv={true}
                disableDownloadPointsCsv={true}
                priorityWarnings={this.props.priorityWarnings}
                reportId={this.props.reportId}
                title={this.props.title}
                warnings={this.props.warnings}
              />
            </div>,
          )}
          <CardContent
            className={'MapCard-CardContent'}
            style={{
              height: this.props.height,
            }}>
            <Map
              buildings={this.props.buildings}
              disableLink={this.props.inStoryboard}
              height={this.props.height}
              meta={this.props.meta}
              reportId={this.props.reportId}
            />
          </CardContent>
        </Card>
      </div>
    );
  }
}
